import { useState } from "react";
import { HeroLayoutProps } from "./HeroProps";
import { KmsTypeHeroProps } from "@mediaspace/shared/types/media/KmsTypeHeroProps";
import { KmsTypeComponent } from "@mediaspace/shared/types/KmsTypeComponent";
import { Converting } from "./converting/Converting";
import { PlayerNotSupported } from "./player-not-supported/PlayerNotSupported";

export interface HeroComponentProps extends HeroLayoutProps, KmsTypeComponent {
    props: KmsTypeHeroProps;
}

/**
 * media-page Hero Component - renders the Hero component, or the status components
 */
export function Hero(props: HeroComponentProps) {
    const {
        component: HeroComponent,
        props: componentProps,
        collapse,
        onToggleCollapse,
        onEntryChange
    } = props;

    const { playerIsV7 = true, topComponents = [] } = componentProps;

    const [converting, setConverting] = useState(componentProps.converting);

    if (!playerIsV7) {
        return <PlayerNotSupported {...componentProps} />;
    }

    return (
        <>
            {topComponents.map((topComponent, index) => {
                const { component: Component, props } = topComponent;
                return <Component key={index} {...props} />;
            })}
            {converting && (
                <Converting
                    {...componentProps}
                    onConversionEnd={() => setConverting(false)}
                />
            )}
            {!converting && (
                <HeroComponent
                    {...componentProps}
                    collapse={collapse}
                    onToggleCollapse={onToggleCollapse}
                    onEntryChange={onEntryChange}
                />
            )}
        </>
    );
}

export default Hero;
